export const languageList = [
  {
    symbol: 'en',
    englishName: 'English',
    originalName: 'English',
    colorId: 'J'
  },
  {
    symbol: 'be',
    englishName: 'Belarusian',
    originalName: 'Беларускі',
    colorId: 'H'
  },
  {
    symbol: 'bg',
    englishName: 'Bulgarian',
    originalName: 'Български',
    colorId: 'I'
  },
  {
    symbol: 'kk',
    englishName: 'Kazakh',
    originalName: 'Қазақ',
    colorId: 'A'
  },
  {
    symbol: 'mk',
    englishName: 'Macedonian',
    originalName: 'Македонски',
    colorId: 'B'
  },
  {
    symbol: 'ru',
    englishName: 'Russian',
    originalName: 'Русский',
    colorId: 'G'
  },
  {
    symbol: 'sr',
    englishName: 'Serbian',
    originalName: 'Српски',
    colorId: 'J'
  },
  {
    symbol: 'sr_Latn',
    englishName: 'Serbian(Latin)',
    originalName: 'Srpski',
    colorId: 'D'
  },
  {
    symbol: 'uk',
    englishName: 'Ukrainian',
    originalName: 'Українська',
    colorId: 'J'
  },
  {
    symbol: 'az',
    englishName: 'Azerbaijani',
    originalName: 'Azərbaycan',
    colorId: 'C'
  },
  {
    symbol: 'bs',
    englishName: 'Bosnian',
    originalName: 'Bosanski',
    colorId: 'K'
  },
  {
    symbol: 'ca',
    englishName: 'Catalan',
    originalName: 'Català',
    colorId: 'C'
  },
  {
    symbol: 'cs',
    englishName: 'Czech',
    originalName: 'Český',
    colorId: 'A'
  },
  {
    symbol: 'kw',
    englishName: 'Cornish',
    originalName: 'Kernewek',
    colorId: 'D'
  },
  {
    symbol: 'da',
    englishName: 'Danish',
    originalName: 'Dansk',
    colorId: 'A'
  },
  {
    symbol: 'de',
    englishName: 'German',
    originalName: 'Deutsch',
    colorId: 'C'
  },
  {
    symbol: 'et',
    englishName: 'Estonian',
    originalName: 'Eesti keel',
    colorId: 'K'
  },
  {
    symbol: 'es',
    englishName: 'Spanish',
    originalName: 'Español',
    colorId: 'E'
  },
  {
    symbol: 'fil',
    englishName: 'Filipino',
    originalName: 'Filipino',
    colorId: 'D'
  },
  {
    symbol: 'fr',
    englishName: 'French',
    originalName: 'Français',
    colorId: 'B'
  },
  {
    symbol: 'ga',
    englishName: 'Irish',
    originalName: 'Gaeilge',
    colorId: 'E'
  },
  {
    symbol: 'gl',
    englishName: 'Galician',
    originalName: 'Galego',
    colorId: 'K'
  },
  {
    symbol: 'hr',
    englishName: 'Croatian',
    originalName: 'Hrvatski',
    colorId: 'B'
  },
  {
    symbol: 'id',
    englishName: 'Indonesian',
    originalName: 'Bahasa Indonesia',
    colorId: 'G'
  },
  {
    symbol: 'is',
    englishName: 'Icelandic',
    originalName: 'Íslenska',
    colorId: 'E'
  },
  {
    symbol: 'it',
    englishName: 'Italian',
    originalName: 'Italiano',
    colorId: 'I'
  },
  {
    symbol: 'sw',
    englishName: 'Swahili',
    originalName: 'Kiswahili',
    colorId: 'H'
  },
  {
    symbol: 'lv',
    englishName: 'Latvian',
    originalName: 'Latviešu',
    colorId: 'G'
  },
  {
    symbol: 'lt',
    englishName: 'Lithuanian',
    originalName: 'Lietuvių',
    colorId: 'I'
  },
  {
    symbol: 'hu',
    englishName: 'Hungarian',
    originalName: 'Magyar',
    colorId: 'D'
  },
  {
    symbol: 'ms',
    englishName: 'Malay',
    originalName: 'Bahasa Melayu',
    colorId: 'E'
  },
  {
    symbol: 'nl',
    englishName: 'Dutch',
    originalName: 'Nederlands',
    colorId: 'C'
  },
  {
    symbol: 'nb',
    englishName: 'Norwegian Bokmal',
    originalName: 'Norsk Bokmal',
    colorId: 'H'
  },
  {
    symbol: 'uz',
    englishName: 'Uzbek',
    originalName: 'O\'zbek',
    colorId: 'J'
  },
  {
    symbol: 'pl',
    englishName: 'Polish',
    originalName: 'Polski',
    colorId: 'G'
  },
  {
    symbol: 'pt_BR',
    englishName: 'Portuguese Brasil',
    originalName: 'Português Brasil',
    colorId: 'C'
  },
  {
    symbol: 'pt_PT',
    englishName: 'Portuguese',
    originalName: 'Português',
    colorId: 'I'
  },
  {
    symbol: 'ro',
    englishName: 'Romanian',
    originalName: 'Română',
    colorId: 'A'
  },
  {
    symbol: 'sq',
    englishName: 'Albanian',
    originalName: 'Shqip',
    colorId: 'D'
  },
  {
    symbol: 'sl',
    englishName: 'Slovene',
    originalName: 'Slovenščina',
    colorId: 'G'
  },
  {
    symbol: 'sk',
    englishName: 'Slovak',
    originalName: 'Slovenčina',
    colorId: 'K'
  },
  {
    symbol: 'fi',
    englishName: 'Finnish',
    originalName: 'Suomi',
    colorId: 'C'
  },
  {
    symbol: 'sv',
    englishName: 'Swedish',
    originalName: 'Svenska',
    colorId: 'I'
  },
  {
    symbol: 'tr',
    englishName: 'Turkish',
    originalName: 'Türkçe',
    colorId: 'J'
  },
  {
    symbol: 'vi',
    englishName: 'Vietnamese',
    originalName: 'Việt nam',
    colorId: 'C'
  },
  {
    symbol: 'el',
    englishName: 'Greek',
    originalName: 'ελληνικά',
    colorId: 'J'
  },
  {
    symbol: 'ka',
    englishName: 'Georgian',
    originalName: 'ქართული',
    colorId: 'B'
  },
  {
    symbol: 'hy',
    englishName: 'Armenian',
    originalName: 'Հայերեն',
    colorId: 'H'
  },
  {
    symbol: 'ne',
    englishName: 'Nepali',
    originalName: 'नेपाली',
    colorId: 'G'
  },
  {
    symbol: 'hi',
    englishName: 'Hindi',
    originalName: 'हिन्दी',
    colorId: 'E'
  },
  {
    symbol: 'bn',
    englishName: 'Bengali',
    originalName: 'বাংলা',
    colorId: 'D'
  },
  {
    symbol: 'gu',
    englishName: 'Gujarati',
    originalName: 'ગુજરાતી',
    colorId: 'J'
  },
  {
    symbol: 'ta',
    englishName: 'Tamil',
    originalName: 'தமிழ்',
    colorId: 'C'
  },
  {
    symbol: 'te',
    englishName: 'Telugu',
    originalName: 'తెలుగు',
    colorId: 'A'
  },
  {
    symbol: 'ml',
    englishName: 'Malayalam',
    originalName: 'മലയാളം',
    colorId: 'D'
  },
  {
    symbol: 'th',
    englishName: 'Thai',
    originalName: 'ไทย',
    colorId: 'E'
  },
  {
    symbol: 'km',
    englishName: 'Khmer',
    originalName: 'ភាសាខ្មែរ',
    colorId: 'A'
  },
  {
    symbol: 'ko',
    englishName: 'Korean',
    originalName: '한국어',
    colorId: 'C'
  },
  {
    symbol: 'ja',
    englishName: 'Japanese',
    originalName: '日本語',
    colorId: 'K'
  },
  {
    symbol: 'zh_CN',
    englishName: 'Chinese Simplified',
    originalName: '简体中文',
    colorId: 'E'
  },
  {
    symbol: 'zh_TW',
    englishName: 'Chinese Traditional',
    originalName: '繁體中文',
    colorId: 'H'
  },
  {
    symbol: 'si',
    englishName: 'Sinhala',
    originalName: 'සිංහල',
    colorId: 'D'
  },
  {
    symbol: 'af',
    englishName: 'Afrikaans',
    originalName: 'Afrikaans',
    colorId: 'B'
  },
  {
    symbol: 'kn',
    englishName: 'Kannada',
    originalName: 'ಕನ್ನಡ',
    colorId: 'E'
  },
  {
    symbol: 'ky',
    englishName: 'Kyrgyz',
    originalName: 'Кыргыз',
    colorId: 'H'
  },
  {
    symbol: 'tg',
    englishName: 'Tajik',
    originalName: 'Тоҷикӣ',
    colorId: 'G'
  }
];
